
import TitleBox from '@/components/CSS/TitleBox'
import TitleBox2 from '@/components/CSS/TitleBox2'

export default {
    components: {
        TitleBox,
        TitleBox2
    },
    data() {
        return {
            list: {},
            loadingRe: true,
            recyclingPayMsgData: {},
            recyclingPayMsgModel: false,
            quotedDeleteModel: false
        }
    },
    methods: {
        recycleState(e) {
            let state = ''
            switch (e) {
                case 3:
                    state = '已报价'
                    break
                case 5:
                    state = '已同意'
                    break
                case 7:
                    state = '已下单'
                    break
            }
            return state
        },
        statusName(status) {
            let name = {
                name: null,
                class: '',
                src: null
            }
            switch (status) {
                case 1:
                    name.name = '报价中'
                    name.class = 'ON_STAND'
                    name.src = 'https://oss.pzds.com/pcv2-img/jinjiazhong.png'

                    break
                case 3:
                    name.name = '待交易'
                    name.class = 'TRADING'
                    name.src = 'https://oss.pzds.com/pcv2-img/jinjiazhong.png'
                    break
                case 5:
                    name.name = '已回收'
                    name.class = 'COMPLETE'
                    name.src = 'https://oss.pzds.com/pcv2-img/COMPLETE.png'
                    break
                case 7:
                    name.name = '已取消'
                    name.class = 'CANCEL'
                    name.src = 'https://oss.pzds.com/pcv2-img/CANCEL.png'
                    break
            }
            return name
        },
        join(e) {
            if (e.imGroupId) {
                this.$store.dispatch('ry/join', { targetId: e.imGroupId, conversationType: 3 })
            } else {
                this.$message({
                    message: '暂无客服值班',
                    type: 'error'
                })
            }
        },
        // 获取详情
        getDetail() {
            this.loadingRe = true
            const info = {
                id: this.$route.query.goodsNo
            }
            this.$api
                .reGoodsDetail(info)
                .then((res) => {
                    this.loadingRe = false
                    if (res.success) {
                        this.list = res.data
                        this.list.goodsImg = this.list.goodsImg && this.list.goodsImg.replace('?x-oss-process=style/jpg90', '?x-oss-process=style/titleImg')
                    }
                })
                .catch((err) => {
                    console.log(err)
                    this.loadingRe = false
                })
        },
        // 回收弹窗显示
        recyclingPayMsgShow(item) {
            // this.recyclingPayMsgData = item
            this.$api.quoteLatestPrice({ id: item.id }).then((res) => {
                if (res.success) {
                    this.recyclingPayMsgData = {
                        id: item.id,
                        ...res.data
                    }
                    this.recyclingPayMsgModel = true
                } else {
                    this.$message.error(res.info)
                }
            })
        },
        // 回收确认
        submitRecyclingPay() {
            let data = {
                id: this.recyclingPayMsgData.id
            }
            this.$api.quotedAgree(data).then((res) => {
                if (res.success) {
                    this.recyclingPayMsgModel = false
                    this.$message.success('操作成功')
                    this.getDetail()
                } else {
                    this.recyclingPayMsgModel = false
                    this.$message.error(res.info)
                }
            })
        },
        // 回收删除
        quotedDelete() {
            let data = {
                id: this.list.id
            }
            this.$api.quotedDelete(data).then((res) => {
                if (res.success) {
                    this.quotedDeleteModel = false
                    this.$message.success('操作成功')
                    this.$router.go(-1)
                } else {
                    this.quotedDeleteModel = false
                    this.$message.error(res.info)
                }
            })
        }
    },
    mounted() {
        this.getDetail()
    }
}
